import { createContext, ReactNode, useContext, useState } from 'react';

type DataType = 'company' | 'people';
type DataTypeMap = { [key: string]: DataType };

interface DataTypeContextType {
  dataTypeMap: DataTypeMap;
  setDataType: (key: string, dataType: DataType) => void;
}

const DataTypeContext = createContext<DataTypeContextType | undefined>(
  undefined
);

export const DataTypeProvider = ({ children }: { children: ReactNode }) => {
  const [dataTypeMap, setDataTypeMap] = useState<DataTypeMap>({});

  const setDataType = (key: string, dataType: DataType) => {
    setDataTypeMap((prev) => ({
      ...prev,
      [key]: dataType,
    }));
  };

  return (
    <DataTypeContext.Provider value={{ dataTypeMap, setDataType }}>
      {children}
    </DataTypeContext.Provider>
  );
};

export const useDataType = () => {
  const context = useContext(DataTypeContext);
  if (!context) {
    throw new Error('useDataType must be used within a DataTypeProvider');
  }
  return context;
};
